<div>
    <h2>Send custom stanza:</h2>
    <textarea rows="10" class="form-control" [(ngModel)]="stanza"></textarea>
    <button (click)="sendStanza()">Send stanza</button>

    <div>Note: responses will not be displayed!</div>
</div>
